<template>
    <v-container>
        <v-row justify="center">
            <v-col md=8 class="text-center">
                <v-card>
                    <v-container fluid>
                        <v-row>
                            <v-col class="text-center display-3 mb-5">
                                Create a Car
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col md=4 class="title">
                                <v-text-field v-model="name" label="Car Name"></v-text-field>
                                <v-text-field v-model="make" label="Make"></v-text-field>
                                <v-text-field v-model="model" label="Model"></v-text-field>
                                <v-text-field v-model="year" label="Year" type="number"></v-text-field>
                                <v-text-field v-model="vin" label="VIN"></v-text-field>
                                <v-text-field v-model="miles" label="Mileage" type="number" min="0"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col md=4>
                                <v-btn block dark color="blue" @click="submit" :loading="loading">
                                    Vroom!
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import rp from "request-promise-native"

export default {
    // Prevent the user from accessing the page if they have not just signedup
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$store.state.signedUp === false) {
                // The following will also forward them to their dashboard if they are already logged in too. Based on the conditions in the SignUp component
                next("/signup");
            } else {
                next();
            }
        })
    },
    data() {
        return {
            name: "",
            make: "",
            model: "",
            year: "",
            vin: "",
            miles: "",
            loading: false
        }
    },
    methods: {
        async submit() {
            // Get the vue instance
            let self = this;
            // TODO Perform field validation eventually

            // Set the loading animation on the button
            this.loading = true;

            // Setup the options for the rp
            let options = {
                method: 'POST',
                uri: `${process.env.VUE_APP_HOST}/cars`,
                auth: {
                    bearer: this.$store.state.token
                },
                body: {
                    name: this.name,
                    make: this.make,
                    model: this.model,
                    year: this.year,
                    mileage: this.miles,
                    vin: this.vin
                },
                json: true // Automatically stringifies the body to JSON
            };

            // Perform the request
            try {
                const res = await rp(options);
                // Set the cars
                this.$store.commit("setCars", [res]);
                // Clear the signedUp variable
                this.$store.commit("clearSignedUp");
                // Push over to dashboard
                this.$router.push("dashboard");
            } catch (e) {
                console.log("Error: ", e);
                self.loading = false;
            }

        }
    }
}
</script>